"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERecoveryMethods = exports.FileRecovery = void 0;
const components_1 = require("@bimser/components");
const core_1 = require("@bimser/core");
const __1 = require("..");
/**Dosyalarda geliştirme esnasında yada kullanıcı bağımlı bozulmuş olan kronik hataları bulup düzeltmek için global yardımcı sınıf */
class FileRecovery {
    static isJSONContent(extension, subType) {
        return (extension === __1.Plugins.SolutionExplorer.Extensions.FLOW_EXTENSION ||
            extension === __1.Plugins.SolutionExplorer.Extensions.ERP_QUERY ||
            extension === __1.Plugins.SolutionExplorer.Extensions.APP_FORM_EXTENSION ||
            extension === __1.Plugins.SolutionExplorer.Extensions.FORM_EXTENSION ||
            extension === __1.Plugins.SolutionExplorer.Extensions.MSSQL_QUERY ||
            extension === __1.Plugins.SolutionExplorer.Extensions.MYSQL_QUERY ||
            extension === __1.Plugins.SolutionExplorer.Extensions.ODBC_QUERY ||
            extension === __1.Plugins.SolutionExplorer.Extensions.POST_GRE_QUERY ||
            extension === __1.Plugins.SolutionExplorer.Extensions.REST_QUERY ||
            extension === __1.Plugins.SolutionExplorer.Extensions.SAP_QUERY ||
            extension === __1.Plugins.SolutionExplorer.Extensions.GPT_QUERY ||
            extension === __1.Plugins.SolutionExplorer.Extensions.SCHEDULER ||
            extension === __1.Plugins.SolutionExplorer.Extensions.WEBSERVICE_QUERY ||
            extension === __1.Plugins.SolutionExplorer.Extensions.ORACLE_QUERY ||
            subType === __1.Plugins.SolutionExplorer.ExplorerFolderType.Flow ||
            subType === __1.Plugins.SolutionExplorer.ExplorerFolderType.SuitForm);
    }
    static writeLog(title, detail, logLevel) {
        if (FileRecovery.log && FileRecovery.canLog) {
            FileRecovery.log({
                message: {
                    pluginId: 'Recovery',
                    sourceWindowId: '',
                    type: __1.Plugins.MessageManager.IMessageTypes.Build,
                    title: title,
                    detail: detail,
                    date: Date.now().toString(),
                    logLevel: logLevel
                }
            });
        }
    }
    static validateCaseSensitive(obj) {
        let result = true;
        Object.keys(obj).forEach(i => {
            if (i.toLowerCase()[0] != i[0]) {
                result = false;
            }
        });
        return result;
    }
    static resolveCaseSensitive(obj) {
        if (typeof obj === 'object') {
            if (Array.isArray(obj)) {
                obj = obj.map(i => {
                    if (typeof i === 'object') {
                        return FileRecovery.resolveCaseSensitive(i);
                    }
                });
            }
            else {
                const keys = Object.keys(obj);
                keys.forEach(key => {
                    const newKey = key[0].toLowerCase() + key.slice(1, key.length);
                    let newValue = obj[key];
                    newValue =
                        typeof newValue === 'object' && Array.isArray(newValue)
                            ? [...newValue]
                            : typeof newValue === 'object'
                                ? Object.assign({}, newValue) : newValue;
                    if (typeof obj[key] === 'object') {
                        newValue = FileRecovery.resolveCaseSensitive(newValue);
                    }
                    obj[newKey] = newValue;
                    if (newKey != key) {
                        delete obj[key];
                    }
                });
            }
        }
        return obj;
    }
    static validate(content, extension) {
        const result = { canbeResolve: true, recoveryMethods: [] };
        try {
            if (FileRecovery.isJSONContent(extension)) {
                if (!core_1.ValidationHelper.CheckJSONString(content)) {
                    result.canbeResolve = false;
                    result.recoveryMethods.push({ type: ERecoveryMethods.BadFormat });
                    FileRecovery.writeLog(components_1.findMessage.get('101291'), components_1.findMessage.get('102505'), __1.Plugins.MessageManager.ILogLevel.ERROR);
                }
                else {
                    const contentObject = JSON.parse(content);
                    if (!FileRecovery.validateCaseSensitive(contentObject)) {
                        result.recoveryMethods.push({
                            type: ERecoveryMethods.CaseSensitive,
                            resolver: FileRecovery.resolveCaseSensitive
                        });
                    }
                }
            }
        }
        catch (error) {
            FileRecovery.writeLog(components_1.findMessage.get('101305'), components_1.findMessage.get('102506'), __1.Plugins.MessageManager.ILogLevel.ERROR);
            FileRecovery.writeLog(components_1.findMessage.get('100926'), error.message, __1.Plugins.MessageManager.ILogLevel.ERROR);
        }
        finally {
            return result;
        }
    }
    static resolve(validation, content, extension) {
        try {
            if (validation === null || validation === void 0 ? void 0 : validation.canbeResolve) {
                let contentObject = JSON.parse(content);
                validation.recoveryMethods.forEach(x => {
                    if (x.resolver) {
                        contentObject = x.resolver(contentObject);
                        FileRecovery.writeLog(components_1.findMessage.get('102191'), components_1.findMessage.get('102507'), __1.Plugins.MessageManager.ILogLevel.SUCCESS);
                    }
                });
                return JSON.stringify(contentObject);
            }
        }
        catch (error) {
            FileRecovery.writeLog(components_1.findMessage.get('102508'), components_1.findMessage.get('102506'), __1.Plugins.MessageManager.ILogLevel.ERROR);
            FileRecovery.writeLog(components_1.findMessage.get('100926'), error.message, __1.Plugins.MessageManager.ILogLevel.ERROR);
            return content;
        }
    }
}
exports.FileRecovery = FileRecovery;
/**Log atılmasının istenmediği durumlarda toggle atılmalıdır */
FileRecovery.canLog = true;
/**Resolve işlemlerinde varsayılan durumları ezebilmek için eklenmiştir */
FileRecovery.customHandlers = [];
var ERecoveryMethods;
(function (ERecoveryMethods) {
    ERecoveryMethods[ERecoveryMethods["BadFormat"] = 0] = "BadFormat";
    ERecoveryMethods[ERecoveryMethods["CaseSensitive"] = 1] = "CaseSensitive";
})(ERecoveryMethods || (exports.ERecoveryMethods = ERecoveryMethods = {}));
//# sourceMappingURL=FileRecovery.js.map